"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedbackMessage = FeedbackMessage;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css");

require("@ta-interaktiv/semantic-ui/semantic/dist/components/message.css");

require("@ta-interaktiv/semantic-ui/semantic/dist/components/list.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * React component that renders a message with a mail address allowing
 * readers to give feedback.
 *
 * @example
 * import React from 'react'
 * import FeedbackMessage from '@ta-interaktiv/react-feedback-message'
 *
 * class YourComponent extends React.Component {
 *  render() {
 *
 *    return (
 *      <FeedbackMessage mailTo='test@example.com' className='small blue' />
 *    )
 *  }
 * }
 *
 * @param {object} props
 * @param {string} [props.mailTo=interaktiv@tages-anzeiger.ch] The mail
 *   address to send the feedback to. Join several addresses with `,`
 * @param {string} [props.project=window.document.title] The name of the
 * project. Used as the mail subject. Defaults to the window title.
 * @param {string} [props.className] Additional CSS classes that should be
 * passed to both the `ui message`.
 * @param {boolean} [props.inverted=false] Whether the component should be
 * displayed as inverted.
 * @param {string} [props.question='Haben sie Anmerkungen oder einen Fehler
 * entdeckt?'] Header line of the feedback message box.
 * @param {string} [props.call='Wir freuen uns über Ihre Nachricht an']
 * Second part of the message, prepended to the mailTo address(es)
 */
function FeedbackMessage(_ref) {
  var _ref$question = _ref.question,
      question = _ref$question === void 0 ? 'Haben Sie Anmerkungen oder einen Fehler entdeckt?' : _ref$question,
      _ref$call = _ref.call,
      call = _ref$call === void 0 ? 'Wir freuen uns über Ihre Nachricht an' : _ref$call,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$inverted = _ref.inverted,
      inverted = _ref$inverted === void 0 ? false : _ref$inverted,
      _ref$mailTo = _ref.mailTo,
      mailTo = _ref$mailTo === void 0 ? 'interaktiv@tages-anzeiger.ch' : _ref$mailTo,
      _ref$project = _ref.project,
      project = _ref$project === void 0 ? window.document.title : _ref$project;
  var invertedClass = inverted ? 'inverted' : '';
  return _react.default.createElement("div", {
    className: "ui ".concat(className, " ").concat(invertedClass, " message feedback-message")
  }, _react.default.createElement("div", {
    className: "ui ".concat(invertedClass, " list")
  }, _react.default.createElement("div", {
    className: "item"
  }, _react.default.createElement("i", {
    className: "comments icon"
  }), _react.default.createElement("div", {
    className: "content"
  }, _react.default.createElement("div", {
    className: "header"
  }, question), call, ' ', _react.default.createElement("a", {
    href: "mailto:".concat(encodeURIComponent(mailTo), "?subject=").concat(encodeURIComponent(project))
  }, mailTo.split(',').join(', ')), "."))));
}

var _default = FeedbackMessage;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-feedback-message/dist/index.js
// module id = 136
// module chunks = 0